module.exports = __webpack_public_path__ + "img/Democratic Republic of Congo.0183e9bd.gif";